<template>
  <a-modal
    title="完善PT费信息"
    :visible="visible"
    :width="800"
    :confirm-loading="submitLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form-model :model="formData" ref="form" class="form-wrapper new-project-modal">
      <a-form-model-item
      v-bind="formLayout"
      label="统计年月">
        <span>{{formData.date}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="结算类型">
        <span>{{formData.settleType}}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="付款类型">
        <span>{{ formData.paymentType }}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="单价">
        <span>{{ formData.price }}</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="数量"
      prop="num"
      key="num"
      :rules="{ required: true, message: ''}">
        <a-input
        type="number"
        v-model="formData.num"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="金额">
        <span>{{ formData.num * formData.price || 0 }}(单价*数量)</span>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="业务目的"
      prop="purpose"
      key="purpose"
      :rules="{ required: true, message: '必填！'}">
        <a-input
        v-model="formData.purpose"
        :maxLength="255"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="备注"
      prop="remark"
      key="remark"
      :rules="{ required: false}">
        <a-input
        v-model="formData.remark"
        :maxLength="200"
        placeholder="请输入"
        :autoSize="{ minRows: 2, maxRows: 6 }"></a-input>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="供应商回票状态"
      prop="invoiceTrackStatus"
      key="invoiceTrackStatus"
      :rules="{ required: false, message: '必填！'}">
      <a-select v-model="formData.invoiceTrackStatus" :allowClear="true" class="project_sn">
          <a-select-option :value="item.key" v-for="(item,index) in invoiceTrackStatusList" :key="index">{{item.val}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
      v-bind="formLayout"
      label="发票日期"
      prop="invoiceDate"
      key="invoiceDate"
      :rules="{ required: false, message: ''}">
        <a-date-picker
        v-model="formData.invoiceDate" format="YYYY-MM-DD">
        </a-date-picker>
      </a-form-model-item>
    </a-form-model>
    <a-form-model-item
      v-bind="formLayout"
      label="上传发票">
      <div>
      <a-upload
        name="file"
        :remove="handleRemove"
        :beforeUpload="beforeUpload"
        accept=".png, .jpg, .jpeg, .ppt, .pptx, .pdf, .doc, .docx, .xls, .xlsx, .xlsm, .xltx, .xltm, .xlsb, .xlam"
        :multiple="false"
        :fileList="fileList"
        action="/api/resource/uploadFile"
        :openFileDialogOnClick="fileList.length < 1"
        :showUploadList=false
      >
        <a-button :disabled="fileList.length >= 1">
          <a-icon type="upload" />上传附件
        </a-button>
      </a-upload>
      <span class="file-list">
        <p class="file" v-for="(file,index) in loadedFileKeys" :key="index">
          <span class="file-name">
            <a-icon type="file" />{{file.file_name}}
          </span>
          <a-icon class="download" style="padding-right: 8px" type="download" @click="download(file)" />
          <a-icon class="download" type="delete" @click="handleRemove" />
        </p>
      </span>
      <p class="upload-desc">支持文件类型：Excel，word，PDF ，PPT，图片（png，jpeg，jpg）；最多上传1个文件，单个文件不大于5M。</p>
      </div>
    </a-form-model-item>
  </a-modal>
</template>

<script>
/* eslint-disable eqeqeq */
import moment from 'moment';
import _ from 'lodash';
import SvgIcUpload from '@/assets/svg/ic-upload.svg';
import PriceAdminService from '../../services/PriceAdminService';
import ProjectManageService from '../../services/ProjectManageService';
import {
  downloadFile
} from '../../utils/tools';
import {
  getCurrentUser,
} from '@/services/user';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SvgIcUpload,
  },
  props: {
    visible: Boolean, // 是否弹窗可见[true, false]
    fileList: Array,
    loadedFileKeys: Array,
    isEdit: Boolean,
    isNew: Boolean,
    formData: {
      type: Object,
      default() {
        return {
          paymentType: undefined, // 付款类型
          settleType: undefined, // 结算类型
          id: undefined,
          price: undefined, // 单价
          date: undefined, // 日期
          applicant: undefined, // 申请人
          payee: undefined, // 收款方
          paymentId: undefined, // 付款类别
          num: undefined, // 数量
          oaAmount: undefined, // 结算金额
          purpose: undefined, // 业务目的
          remark: undefined, // 备注
          invoiceTrackStatus: undefined, // 供应商汇票日期
          invoiceDate: undefined, // 发票日期
          file_list: [],
        };
      }
    },
  },
  data() {
    return {
      submitLoading: false,
      payTypeList: [],
      monthFormat: 'YYYY-MM',
      formLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 17
        }
      },
      invoiceTrackStatusList: [
        { key: 1, val: '未追踪' },
        { key: 2, val: '部分回票' },
        { key: 3, val: '发票已回' },
      ],
    };
  },

  methods: {
    disabledDate(current) {
      return (
        current
        && (current > moment().endOf('day') || current < moment('20190501'))
      );
    },
    handleOk() {
      this.$refs.form.validate((err, fieldsValue) => {
        if (!err) {
          this.$Message.error('请完善数据');
          return;
        }
        const tempList = [];
        this.fileList.forEach((item) => {
          tempList.push({ file_key: item.file_key, file_name: item.name });
        });
        this.submitLoading = true;
        this.formData.file_list = tempList;
        if (typeof this.formData.date !== 'string' && this.formData.date) {
          this.formData.date = this.formData.date.format('YYYY-MM');
        }
        if (typeof this.formData.invoiceDate !== 'string' && this.formData.invoiceDate) {
          this.formData.invoiceDate = this.formData.invoiceDate.format('YYYY-MM-DD');
        }
        this.formData.oaAmount = this.formData.num * this.formData.price;
        ProjectManageService.editPT(this.formData).then((res) => {
          this.submitLoading = false;
          if (res.status === 'success') {
            this.$Message.success('完善成功');
            this.$emit('refresh');
            this.$emit('cancel');
          } else {
            this.$Message.error(res.message);
          }
        });
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleRemove(file) {
      this.loadedFileKeys.splice(0);
      this.fileList.splice(0);
    },
    beforeUpload(file) {
      if (this.fileList.length >= 1) {
        this.$Message.error('只允许上传一个文件');
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 <= 5;
      let hasSameNameFile = false;
      if (!isLt5M) {
        this.$Message.error('单文件不能大于 5MB！');
        return false;
      }
      this.fileList.forEach((item) => {
        if (item.name === file.name) {
          hasSameNameFile = true;
          this.$Message.warning('该文件名与已上传文件名相同');
        }
      });
      if (isLt5M && !hasSameNameFile) {
        this.handleFileChange(file);
      }
      return false;
    },
    handleFileChange(file) {
      const formData = new FormData();
      formData.append('file', file);
      return PriceAdminService.uploadFile(formData)
        .then((res) => {
          if (res.status === 'success') {
            file.file_key = res.data.file_key;
            this.fileList = [];
            this.loadedFileKeys = [];
            this.fileList.push(file);
            this.$Message.success(`${file.name}上传成功！`);
            this.loadedFileKeys.push({
              file_key: res.data.file_key,
              file_name: file.name
            });
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.$Message.error(`${file.name}上传失败！`);
        });
    },
    download({ file_key, file_name }) {
      PriceAdminService.getFileLink({ file_key }).then((res) => {
        if (res.status === 'success') {
          downloadFile(res.data.url, file_name);
        } else {
          this.$Message.error(res.message.description);
        }
      }).catch((err) => {
        this.$Message.error(err.data.message.description);
      });
    },
  },
  mounted() {
    ProjectManageService.paymentTypeList().then((res) => {
      if (res.status === 'success') {
        this.payTypeList = res.data;
      } else {
        this.$Message.error(res.message);
      }
    });
  },

};
</script>

<style lang="less">
.file-required{
    .ant-form-item-label::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
}
}
.new-project-modal {
  padding: 8px 0;
  .ant-upload-disabled {
    .ant-btn-default {
      background: #efefef;
    }
  }
  .ant-form-item {
    margin-bottom: 13px;
  }
  .ant-form-item-control-wrapper {
    margin-left: 8px;
  }
  .file-list {
    display: block;
    margin-top: 8px;
    .file {
      cursor: pointer;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      line-height: 21px;
      height: 21px;
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
        display: inline-block;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .download {
        opacity: 0;
        position: absolute;
        right: 2px;
        margin: 4px 0 0 0;
        cursor: pointer;
        &:first-of-type {
          right: 20px;
        }
      }
      &:hover {
        background: #e6f9ff;
        .download {
          opacity: 1;
        }
      }
      .file-name {
        .anticon {
          margin-right: 4px;
        }
      }
    }
  }
}
.file-list {
    display: block;
    margin-top: 8px;
    .file {
      cursor: pointer;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      line-height: 21px;
      height: 21px;
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
        display: inline-block;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .download {
        opacity: 0;
        position: absolute;
        right: 2px;
        margin: 4px 0 0 0;
        cursor: pointer;
        &:first-of-type {
          right: 20px;
        }
      }
      &:hover {
        background: #e6f9ff;
        .download {
          opacity: 1;
        }
      }
      .file-name {
        .anticon {
          margin-right: 4px;
        }
      }
    }
  }
</style>
